type ActiveFlags = {
  [variation: string]: string;
  flagKey: string;
  variationA: string;
  variationB: string;
};

export const currencyTest: ActiveFlags = {
  flagKey: 'currency-test',
  variationA: 'A',
  variationB: 'B',
};
